import { render, staticRenderFns } from "./NewOrderNormalGrid.vue?vue&type=template&id=2e3a2ada&"
import script from "./NewOrderNormalGrid.vue?vue&type=script&lang=js&"
export * from "./NewOrderNormalGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/NewOrderNormalGrid.vue
// module id = null
// module chunks = 